/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react'
import {Flex} from '@instructure/ui-flex'
import {Text} from '@instructure/ui-text'
import {Heading} from '@instructure/ui-heading'
import {useScope as createI18nScope} from '@canvas/i18n'
import {SurveyLinkBox} from '@canvas/discussions/react/components/SurveyLinkBox/SurveyLinkBox'

const I18n = createI18nScope('discussion_insights')

const InsightsHeader = () => {
  return (
    <Flex padding="0 0 large 0" direction="column" as="div" width="100%" gap="small">
      <Flex.Item>
        <Heading as="h1" level="h1">
          {I18n.t('Discussion Insights')}
        </Heading>
      </Flex.Item>
      <Flex.Item direction="column" as="div">
        <Text>
          {I18n.t(
            'Insights are generated by AI and reflect contributions to the discussion. Please note that the output may not always be accurate. Insights are only visible to instructors.',
          )}
        </Text>
      </Flex.Item>
      <Flex.Item>
        <SurveyLinkBox
          url={ENV.discussion_ai_survey_link}
          text={I18n.t('What do you think of *Discussion Insights*?', {
            wrappers: [`<strong>$1</strong>`],
          })}
        />
      </Flex.Item>
    </Flex>
  )
}

export default InsightsHeader
